import classNames from "classnames";
import PropTypes from "prop-types";
import { TextField } from "../Create/Fields";

const Environment = ({ ready, labels }) => (
  <section className="onboarding__section">
    <div className="onboarding__title-row">
      <h3 className="onboarding__section-title">{labels.TITLE}</h3>
      <span
        className={classNames("onboarding__badge", {
          "onboarding__badge--done": ready,
          "onboarding__badge--todo": !ready,
        })}
      >
        {ready ? labels.STATUS.READY : labels.STATUS.MISSING}
      </span>
    </div>
    <div className="onboarding__grid">
      <TextField
        name="environment.url"
        label={labels.URL}
        type="url"
        autoComplete="off"
        placeholder={labels.URL_PLACEHOLDER}
      />
      <TextField
        name="environment.apiKey"
        label={labels.API_KEY}
        type="password"
        autoComplete="new-password"
        placeholder={ready ? labels.API_KEY_KEEP : labels.API_KEY_PLACEHOLDER}
      />
    </div>
  </section>
);

Environment.propTypes = {
  ready: PropTypes.bool,
  labels: PropTypes.object.isRequired,
};

Environment.defaultProps = {
  ready: false,
};

export default Environment;
